export default __webpack_public_path__ + "static/media/tl-logo-text.54540601.png";